// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1zhWt","requiredAsterisk":"Info_requiredAsterisk__1TMHA"};